import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import CameraIcon from "@mui/icons-material/Camera";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PeopleIcon from "@mui/icons-material/People";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import EmailIcon from "@mui/icons-material/Email";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useRef } from "react";
import AuthContext from "../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function Sidebar({ open, handleDrawerToggle, returnFocusRef }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();
  const drawerRef = useRef(null);

  const menuItems = [
    { text: t("dashboard"), icon: <HomeIcon />, path: "/dashboard" },
    { text: t("cameras"), icon: <CameraIcon />, path: "/dashboard/cameras" },
    { text: "Previsiones", icon: <AssignmentIcon />, path: "/dashboard/previsiones" },
  ];

  if (user?.is_admin) {
    menuItems.push(
      { text: "Reporte email", icon: <EmailIcon />, path: "/dashboard/email-reports" },
      { text: t("clients"), icon: <PeopleIcon />, path: "/dashboard/clients" },
      { text: t("users"), icon: <PeopleOutlineIcon />, path: "/dashboard/users" }
    );
  }

  const closeDrawerSafely = () => {
    const active = document.activeElement;
    if (drawerRef.current && active instanceof HTMLElement && drawerRef.current.contains(active)) {
      active.blur();
    }
    handleDrawerToggle();
    // After state updates, ensure focus goes to a safe target outside the Drawer
    requestAnimationFrame(() => {
      const target = returnFocusRef?.current;
      if (target && typeof target.focus === 'function') {
        target.focus();
      } else {
        // fallback: focus the document body
        document.body.focus?.();
      }
    });
  };

  return (
    <Drawer
      variant="temporary"
      open={open}
      onClose={closeDrawerSafely}
      disableRestoreFocus
      ModalProps={{ keepMounted: true }}
      slotProps={{ paper: { inert: !open || undefined } }}
      sx={{ "& .MuiDrawer-paper": { width: 260 } }}
    >
      <Toolbar />
      <List disablePadding>
        {menuItems.map((item) => {
          const selected =
            location.pathname === item.path ||
            location.pathname.startsWith(item.path + "/");

          return (
            <ListItem disablePadding key={item.path}>
              <ListItemButton
                selected={selected}
                onClick={(e) => {
                  e.currentTarget.blur();
                  navigate(item.path);
                  closeDrawerSafely();
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}
